import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './Button.module.css'

class Button extends Component {
  // constructor(props) {
  //   super(props)
  // }

  render() {
    Button.propTypes = {
      children: PropTypes.any,
      style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
      title: PropTypes.string,
      type: PropTypes.string,
      onClick: PropTypes.func
    }

    Button.defaultProps = {
      type: 'button',
      title: null,
      onClick: () => {
        console.log('clicked')
      }
    }

    Button.displayName = 'b'
    const arch = (Component) => (props) => {
      return <Component {...props} />
    }

    const ButtonBase = arch('button')
    // const DivBase = arch('div')
    ButtonBase.displayName = 'b'
    const { style, children, title, type, onClick } = this.props
    return (
      <ButtonBase
        className={styles['bt-xyz-root']}
        style={style}
        title={title}
        type={type}
        onClick={onClick}
        {...this.props}
      >
        {children}
      </ButtonBase>
    )
  }
}

export default Button
